var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 197L198.547 177L175.453 177L187 197ZM187 82L175.453 102L198.547 102L187 82ZM189 179L189 100L185 100L185 179L189 179Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 15L94 3.45299V26.547L114 15ZM4 15L24 26.547V3.45299L4 15ZM96 13L22 13V17H96V13Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 57.2505L28.2461 33H68.0377L4 97.0493V57.2505ZM4 176.647V136.848L106.243 34.5868C109.006 36.3663 110.835 39.4695 110.835 43V69.7924L4 176.647ZM63.2339 197H23.4423L134.049 86.3728H157C161.562 86.3728 165.411 89.4277 166.612 93.6035L63.2339 197ZM142.817 197H103.025L167 133.014V172.813L142.817 197Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 187V43C4 37.4772 8.47715 33 14 33H100.835C106.358 33 110.835 37.4771 110.835 43V76.3728C110.835 81.8956 115.312 86.3728 120.835 86.3728H157C162.523 86.3728 167 90.8499 167 96.3728V187C167 192.523 162.523 197 157 197H14C8.47715 197 4 192.523 4 187Z",
    stroke: "#062134",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsArea);
export default __webpack_public_path__ + "static/media/ico_buildings_area.d8ee0a7147c82bb5b5bd87be5544e820.svg";
export { ForwardRef as ReactComponent };